/**
 * Generic Trigger Behavior
 * 
 * Basic trigger that just emits events. Used as fallback.
 */

import { EntityType } from '../../types/EntityTypes';
import type { TriggerBehavior } from '../../types/TriggerTypes';
import { logger } from '../../core/Logger';

export const genericTriggerBehavior: TriggerBehavior = {
  id: 'trigger:generic',
  displayName: 'Generic Trigger',
  type: EntityType.TRIGGER_ZONE,
  category: 'trigger',
  tags: ['basic', 'event'],
  
  parameters: {},
  
  onEnter: (api) => {
    const { ctx } = api;
    logger.triggers.log(`🎯 Generic trigger ${ctx.self.id}: entity ${ctx.entrant.id} entered`);
  },
  
  onExit: (api) => {
    const { ctx } = api;
    logger.triggers.log(`🎯 Generic trigger ${ctx.self.id}: entity ${ctx.exiter.id} exited`);
  }
};
